import { useState } from 'react';
import { FiltersMap, OptionalFiltersMap } from '@wix/bex-core';
import {
  CursorCollectionConfig,
  useWixPatternsContainer,
  useCreateCollection,
} from '@wix/bex-core/react';
import { InfiniteScrollTableState } from '../state';

/**
 * @deprecated use useTable instead
 */
export function useCursorInfiniteScrollTable<
  T,
  F extends FiltersMap = OptionalFiltersMap,
>(config: CursorCollectionConfig<T, F>) {
  const createCollection = useCreateCollection();
  const container = useWixPatternsContainer();

  const [state] = useState(
    () =>
      new InfiniteScrollTableState({
        collection: createCollection<T, F>({
          ...config,
          paginationMode: 'cursor',
        }),
        container,
      }),
  );

  return state;
}
